export const getStudioTypeNames = (
  studioType?: string | { content?: { name?: string } } | (string | { content?: { name?: string } })[],
  allTypes: { uuid: string; name: string }[] = []
): string[] => {
  if (!studioType) return []
  const arr = Array.isArray(studioType) ? studioType : [studioType]
  return arr
    .map(type => {
      if (typeof type === "object" && type.content?.name) return type.content.name
      if (typeof type === "string") {
        const found = allTypes.find(t => t.uuid === type)
        return found ? found.name : type
      }
      return ""
    })
    .filter(Boolean)
}

// Pass allExtras (array of { uuid, name }) to this function
export const getExtra = (
  extra: string | { content?: { name?: string; _uid?: string } } | (string | { content?: { name?: string; _uid?: string } })[],
  allExtras: { uuid: string; name: string }[]
): string[] => {
  if (!extra) return []
  const arr = Array.isArray(extra) ? extra : [extra]
  return arr
    .map(e => {
      if (typeof e === "object" && e.content?.name) return e.content.name
      if (typeof e === "string") {
        // Try to find the name by UUID
        const found = allExtras.find(ex => ex.uuid === e)
        return found ? found.name : e
      }
      return ""
    })
    .filter(Boolean)
}
